import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

export interface IPostAuthFederationConnectorRequest {
  connectorClass: string;
  audience: string;
}

export interface IPostAuthFederationConnectorResponse {
  connector: {
    luid: string;
    connectorClass: string;
    audience: string;
  };
}

export function postAuthFederationConnectorRequestConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.30',
    httpMethod: 'POST',
    endpoint: 'auth-federation/admin/connectors',
    serverWideRequest: false
  };
}

export function callPostAuthFederationConnectorRequest(
  request: IPostAuthFederationConnectorRequest
): Promise<IPostAuthFederationConnectorResponse> {
  return makeJsonRestApiRequest<IPostAuthFederationConnectorRequest, any>({
    config: postAuthFederationConnectorRequestConfig(),
    request
  }).then((response) => {
    return {
      connector: response.authFederationConnector
    };
  });
}
